<template>
  <div class="aboutus-box" style="padding: 50px 30px;">
    <div 
      style="
        font-weight: 600;
        font-size: 24px;
        text-align: center;
        margin: 20px auto 40px;
        width: 70%;
      "
    >
      {{ $t('other.homeaboutustitle') }}
    </div>
    <van-row style="margin-bottom: 25px;border-bottom: 1px solid #eee;padding-bottom: 10px;">
      <van-col :span="6">
        <div style="width: 60px;height: 60px;">
          <img src="../../../assets/22052205.png" style="width: 100%;height: 100%;" />
        </div>
      </van-col>
      <van-col :span="18">
        <p style=" font-weight: 600; font-size: 20px">
          {{ $t('other.homeaboutustitle1') }}
        </p>
        <span style="font-size: 14px"
          >{{ $t('other.homeaboutusdesc1') }}</span
        >
      </van-col>
    </van-row>
    <van-row style="margin-bottom: 25px;border-bottom: 1px solid #eee;padding-bottom: 10px;">
      <van-col :span="6"><div style="width: 60px;height: 60px;">
        <img src="../../../assets/22052206.png" style="width: 100%;height: 100%;" /></div>
      </van-col>
      <van-col :span="18">
        <p style="font-weight: 600; font-size: 20px">
          {{ $t('other.homeaboutustitle2') }}
        </p>
        <span style=" font-size: 14px"
          >{{ $t('other.homeaboutusdesc2') }}</span
        >
      </van-col>
    </van-row>
    <van-row style="margin-bottom: 25px;border-bottom: 1px solid #eee;padding-bottom: 10px;">
      <van-col :span="6"><div style="width: 60px;height: 60px;">
        <img src="../../../assets/22052207.png" style="width: 100%;height: 100%;" /></div>
      </van-col>
      <van-col :span="18">
        <p style="font-weight: 600; font-size: 20px">
          {{ $t('other.homeaboutustitle3') }}
        </p>
        <span style=" font-size: 14px"
          >{{ $t('other.homeaboutusdesc3') }}</span
        >
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'AboutUsView'
}
</script>

<style></style>
